import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // useNavigateをインポート
import { useAuth } from "react-oidc-context"; // useAuthフックをインポート

const RecipeList = React.memo(({ recipes, onRecipeUpdated, api }) => {
  const navigate = useNavigate(); // useNavigateフックを初期化
  const [error, setError] = useState('');
  const auth = useAuth(); // useAuthフックを初期化
  const isLoggedIn = auth.isAuthenticated; // 認証状態を取得

  const handleDeleteRecipe = async (event, recipeId) => {
    event.stopPropagation(); // イベントの伝播を停止
    if (!window.confirm('本当にこのレシピを削除しますか？')) return;
    try {
      await api.delete(`/recipe/${recipeId}`); // 削除APIは共通
      const endpoint = isLoggedIn ? '/recipes/user' : '/recipes';
      const response = await api.get(endpoint);
      onRecipeUpdated?.(response.data);
    } catch (err) {
      console.error('レシピ削除エラー:', err);
      setError('レシピの削除中にエラーが発生しました。');
    }
  };

  const handleCardClick = (recipeId) => {
    navigate(`/recipes/${recipeId}`); // 詳細画面へ遷移
  };



  if (error) return <p style={{ color: 'red' }}>{error}</p>;
  if (!recipes || recipes.length === 0) return <p>まだレシピが登録されていません。</p>;

  return (
    <div style={{ marginTop: '40px' }}>
      <h2>{isLoggedIn ? '登録済みレシピ' : '公開されている登録済みレシピ'}</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '20px' }}>
        {recipes.map((recipe) => (
          <div
            key={recipe.id}
            style={{ border: '1px solid #eee', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 5px rgba(0,0,0,0.1)', cursor: 'pointer' }}
            onClick={() => handleCardClick(recipe.id)} // クリックイベントを追加
          >
            <img
              src={recipe.image_path}
              alt={recipe.title}
              style={{ width: '100%', height: '200px', objectFit: 'cover' }}
            />
            <div style={{ padding: '15px' }}>
              <h3 style={{ margin: '0 0 10px 0', fontSize: '1.2em' }}>
                {recipe.title}
              </h3>

              {recipe.status === 'processing' && (
                <p style={{ fontSize: '0.9em', color: '#555' }}>状態: AI処理中</p>
              )}

              {recipe.status === 'completed' && (
                <>
                  <div style={{ fontSize: '0.9em', color: '#555', marginBottom: '10px' }}>
                    {recipe.ai_adjusted_recipe && typeof recipe.ai_adjusted_recipe === 'object' && (
                      <>
                        {Number.isFinite(recipe.ai_adjusted_recipe.total_time_min) && (
                          <p style={{ margin: '0' }}>時間: 約{recipe.ai_adjusted_recipe.total_time_min}分</p>
                        )}
                        {recipe.ai_adjusted_recipe.ingredients && recipe.ai_adjusted_recipe.ingredients.length > 0 && (
                          <p style={{ margin: '0' }}>材料: {recipe.ai_adjusted_recipe.ingredients.map(ing => ing.name).join(', ')}</p>
                        )}
                      </>
                    )}
                  </div>
                  <p style={{ fontSize: '0.9em', color: '#555' }}>
                  </p>
                </>
              )}

              {recipe.status === 'error' && (
                <p style={{ color: 'red', fontSize: '0.9em' }}>レシピの処理中にエラーが発生しました。</p>
              )}

              {isLoggedIn && (
                <button
                  onClick={(event) => handleDeleteRecipe(event, recipe.id)}
                  style={{
                    backgroundColor: '#dc3545',
                    color: 'white',
                    border: 'none',
                    padding: '8px 12px',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    marginTop: '10px',
                    fontSize: '0.9em'
                  }}
                >
                  削除
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}); // ここに閉じ括弧とセミコロンを追加

export default RecipeList;
